/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { ViewBlueprintsModalEntryPointEntrypointProps } from './ViewBlueprintsModalEntryPoint.entrypoint.types.tsx';
import type { ViewBlueprintsModalProps } from './ViewBlueprintsModalProps.types.tsx';

type EntryPointParams = ViewBlueprintsModalProps;

type ViewBlueprintsEntrypointComponent = EntryPointComponent<
	{},
	{},
	ViewBlueprintsModalEntryPointEntrypointProps,
	{}
>;

export const viewBlueprintsEntrypoint: EntryPoint<
	ViewBlueprintsEntrypointComponent,
	EntryPointParams
> = createEntryPoint({
	root: JSResourceForInteraction<ViewBlueprintsEntrypointComponent>(
		/* webpackChunkName: "async-jpd-component-view-blueprints-modal" */ './ViewBlueprintsModalEntryPoint.tsx',
	),
	getPreloadProps: (_: EntryPointParams) => ({}),
});
